export default function transformTextareaStringToArray(text?: string) {
  if (!text) {
    return [];
  }
  const splitTextArray = text.split('\n');
  const cleanedTextArray = splitTextArray.reduce((acc, curr) => {
    const trimmed = curr.trim();
    if (trimmed) {
      acc.push(trimmed);
    }
    return acc;
  }, [] as string[]);

  return cleanedTextArray;
}
